module.exports = __webpack_public_path__ + "img/53ne.a0e7df40.svg";